import React from 'react';
import { Button } from 'react-bootstrap';

type CancelButtonProps = {
  isDirty?: boolean;
  isSubmitting?: boolean;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
};

export const CancelButton: React.FC<React.PropsWithChildren<CancelButtonProps>> = ({
  isDirty = false,
  isSubmitting = false,
  className,
  disabled,
  onClick,
  children,
}) => {
  return (
    <Button variant="secondary" disabled={!!disabled || !isDirty || isSubmitting} className={className} onClick={onClick}>
      {children}
    </Button>
  );
};
